module.exports = __webpack_public_path__ + "static/img/a.803c447e.png";